import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { toUserSelectItem } from '../../../../../../User'
import { WidgetContentItemsList } from '../../../../../../Widget'
import { REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS } from '../../../RequestProfileWidgetProviders.constants'
import { RequestProfileWidgetProvidersRecommendedProviderItem } from '../../../RequestProfileWidgetProvidersRecommendedProviderItem'

import * as styles from '../RequestProfileWidgetProvidersFormFields.module.css'

function RecommendedProvidersField({
  initialRecommendedProviderId,
  recommendationTooltipKey,
  recommendedProviders,
  requestPermissions,
}) {
  const { t } = useTranslation()

  const { isSubmitting, setFieldValue, values } = useFormikContext()

  const selectedProviderIds = new Set(
    values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS].map(
      item => item.value
    )
  )

  const filteredRecommendedProviders = recommendedProviders.filter(
    item => !selectedProviderIds.has(item.id)
  )

  function handleAddRecommendedProvider(itemId) {
    const selectedProviders =
      values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS]
    const recommendedProvider = recommendedProviders.find(
      item => item.id === itemId
    )

    if (
      recommendedProvider &&
      !selectedProviders.some(item => item.value === itemId)
    ) {
      setFieldValue(REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS, [
        ...selectedProviders,
        toUserSelectItem(recommendedProvider),
      ])
    }
  }

  useEffect(() => {
    if (initialRecommendedProviderId) {
      handleAddRecommendedProvider(initialRecommendedProviderId)
    }
  }, [])

  return filteredRecommendedProviders.length > 0 ? (
    <div className={styles.section}>
      <WidgetContentItemsList
        Item={RequestProfileWidgetProvidersRecommendedProviderItem}
        info={t(recommendationTooltipKey)}
        itemProps={{
          canAdd: requestPermissions?.can_edit_contractors,
          isDisabled: isSubmitting,
          onAdd: handleAddRecommendedProvider,
        }}
        items={filteredRecommendedProviders}
        title={t('RequestProfile.ProvidersRecommendedProvidersTitleKey', {
          count: filteredRecommendedProviders.length,
        })}
      />
    </div>
  ) : null
}

export default RecommendedProvidersField
